/* eslint-disable no-open-modules-imports */

import type { FeatureGroup } from 'feature/feature-helpers';
import { COMPOSITE, SECTION } from 'feature/feature-helpers';
import { ProfileTitledWriterFeature } from 'open-modules/cbcrc/feature/profile/profile-titled-writer';
import { ProfileArticleRecommendationsFeature } from 'open-modules/zdf/feature/profile-article-recommendations';
import { ProfileConversationRecommendationsFeature } from 'open-modules/zdf/feature/profile-conversation-recommendations';
import { ProfileInterestsFeature } from 'open-modules/zdf/feature/profile-interests';
import { ProfileSettingsFeature } from 'open-modules/zdf/feature/profile-settings';
import { t } from 'util/stdtypes';

import { ProfileAnswersFeature } from './profile-answers';
import { ProfileCommentsFeature } from './profile-comments';
import { ProfileConfigFeature } from './profile-config';
import { ProfilePhotoAndNameFeature } from './profile-photo-and-name';

export const profileFeatures: FeatureGroup[] = [
    SECTION(t('Developer'), [ProfileConfigFeature]),
    SECTION(t('General'), [ProfilePhotoAndNameFeature, ProfileAnswersFeature, ProfileCommentsFeature]),
    SECTION(t('ZDF'), [
        ProfileInterestsFeature,
        ProfileConversationRecommendationsFeature,
        ProfileArticleRecommendationsFeature,
        COMPOSITE(ProfileSettingsFeature, []),
    ]),
    SECTION(t('CBCRC'), [ProfileTitledWriterFeature]),
];

export const profileDefaultConfig = {
    profileanswers: true,
    profiledelete: true,
    profileeditname: true,
};
